import Permission from '@/classes/Permission'
import Ui from '@/classes/Ui'
import Field from '@/components/helpers/DataInput/Field'

export let updateMixin = {
  props: ['id'],
  components: { Field },
  data() {
    return {
      item: {},
      type: '',
      errors: [],
      level: 2,
      retrieve_method: 'show'
    }
  },
  computed: {
    title() {
      return 'ui.pages.item-' + this.type
    },
    singular_model() {
      return this.model.slice(0, -1)
    },
    redirection() {
      return { name: this.model }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    update() {

      this.api.post(this.item).then((item) => {

        this.item = item
        if (this.$route.name === "user_edit" && item.id === this.$store.state.current_user.id){
          this.updateCurrentUser(item)
        }

        if (this.$route.name === 'user_profile') {
          item.firstname = this.currentUser.firstname
          item.lastname = this.currentUser.lastname
          this.updateCurrentUser(item)
        }
        this.$router.push('/')
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + this.singular_model + '.message.' + this.type,
          'type': 'success'
        })
        this.$router.push(this.redirection)
      }).catch((e) => {
        console.log(e.response.data)
        this.errors = e.response.data.errors
      })
    },
    updateCurrentUser(item) {
      item.overwrite = true
      this.$store.commit('SET_CURRENT_USER', item)
    },
    cancel() {
      this.$router.push(this.redirection)
    },
    retrieve(id) {
      this.api[this.retrieve_method](id).then((item) => {
        this.item = item
        Ui.setTitle({ label: this.title, params: { name: item.name }})
        Ui.setPageType(this.singular_model)
        Ui.finishLoading()
        this.afterRetrieve()
      }).catch(function(error) {
        console.log(error)
      })
    },
    afterRetrieve(){

    },
    init() {
      this.item = {}
      let permissions = Permission.loadPermissions()
      if (this.id || this.retrieve_method !== "show") {
        this.type = "update"
      } else {
        this.type = "create"
      }
      if (Permission.can(permissions, this.model + '.' + this.type)) {
        Ui.setPageLevel(this.level)
        Ui.startLoading()

        if (this.type == "update") {
          this.retrieve(this.id)
        } else {
          Ui.setTitle({ label: this.title })
          Ui.finishLoading()
        }
      } else {
        this.$store.commit('ADD_ERROR', {
          type: 'warning',
          message: 'errors.unauthorized'
        })
        this.$router.push({ name: 'unauthorized' })
      }
    }
  },
  watch: {
    '$route.params.id' (newId, oldId) {
      this.init()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Update.js